export const colourNeutral01 = 'hsl(176, 12%, 16%)';
export const colourNeutral02 = 'hsl(176, 12%, 23%)';
export const colourNeutral03 = 'hsl(176, 10%, 30%)';
export const colourNeutral04 = 'hsl(176, 10%, 39%)';
export const colourNeutral05 = 'hsl(176,  8%, 49%)';
export const colourNeutral06 = 'hsl(176,  8%, 60%)';
export const colourNeutral07 = 'hsl(176,  8%, 70%)';
export const colourNeutral08 = 'hsl(176, 10%, 80%)';
export const colourNeutral09 = 'hsl(176, 10%, 89%)';
export const colourNeutral10 = 'hsl(176, 12%, 96%)';
export const colourNeutral11 = 'hsl(176, 12%, 98%)';

export const colourGreen01 = 'hsl(180, 97%, 15%)';
export const colourGreen02 = 'hsl(178, 80%, 23%)';
export const colourGreen03 = 'hsl(176, 55%, 28%)';
export const colourGreen04 = 'hsl(174, 54%, 34%)';
export const colourGreen05 = 'hsl(172, 53%, 41%)';
export const colourGreen06 = 'hsl(170, 51%, 49%)';
export const colourGreen07 = 'hsl(168, 51%, 62%)';
export const colourGreen08 = 'hsl(166, 52%, 74%)';
export const colourGreen09 = 'hsl(164, 53%, 87%)';
export const colourGreen10 = 'hsl(162, 54%, 96%)';

export const colourYellow01 = 'hsl(43, 86%, 17%)';
export const colourYellow02 = 'hsl(43, 77%, 27%)';
export const colourYellow03 = 'hsl(43, 72%, 37%)';
export const colourYellow04 = 'hsl(43, 63%, 48%)';
export const colourYellow05 = 'hsl(43, 78%, 60%)';
export const colourYellow06 = 'hsl(43, 89%, 70%)';
export const colourYellow07 = 'hsl(43, 90%, 76%)';
export const colourYellow08 = 'hsl(43, 86%, 81%)';
export const colourYellow09 = 'hsl(43, 90%, 88%)';
export const colourYellow10 = 'hsl(43, 100%, 96%)';

export const colourRed01 = 'hsl(348, 92%, 20%)';
export const colourRed02 = 'hsl(348, 85%, 25%)';
export const colourRed03 = 'hsl(348, 79%, 32%)';
export const colourRed04 = 'hsl(350, 72%, 38%)';
export const colourRed05 = 'hsl(352, 67%, 44%)';
export const colourRed06 = 'hsl(354, 64%, 55%)';
export const colourRed07 = 'hsl(356, 71%, 66%)';
export const colourRed08 = 'hsl(358, 77%, 78%)';
export const colourRed09 = 'hsl(358, 82%, 89%)';
export const colourRed10 = 'hsl(360, 100%, 97%)';

export const colourPurple01 = 'hsl(292, 27%, 20%)';
export const colourPurple02 = 'hsl(292, 25%, 25%)';
export const colourPurple03 = 'hsl(292, 19%, 32%)';
export const colourPurple04 = 'hsl(292, 15%, 38%)';
export const colourPurple05 = 'hsl(292, 17%, 44%)';
export const colourPurple06 = 'hsl(292, 14%, 55%)';
export const colourPurple07 = 'hsl(292, 21%, 66%)';
export const colourPurple08 = 'hsl(292, 37%, 78%)';
export const colourPurple09 = 'hsl(292, 42%, 89%)';
export const colourPurple10 = 'hsl(292, 50%, 97%)';

export const colourPrimaryWarmGrey = 'hsl(27, 9%, 43.5%)';
export const colourPrimaryRed = 'hsl(348, 87.9%, 38.8%)';
export const colourPrimaryOrange = 'hsl(18, 100%, 51%)';
export const colourPrimaryYellow = 'hsl(43, 100%, 50%)';
export const colourPrimarySeaGreen = 'hsl(176, 100%, 26.1%)';
export const colourPrimaryLightBlue = 'hsl(183, 100%, 36.3%)';
export const colourPrimaryDarkBlue = 'hsl(199, 88.3%, 23.5%)';
export const colourPrimaryDarkPurple = 'hsl(292, 31.9%, 28.2%)';
export const colourPrimaryLightPurple = 'hsl(326, 100%, 33.3%)';

export const colourSecondaryWarmGrey = 'hsl(28, 10.4%, 68%)';
export const colourSecondaryLightBlue = 'hsl(206, 29.6%, 86.1%)';
export const colourSecondaryGreen = 'hsl(62, 62.5%, 65.5%)';
export const colourSecondaryBlue = 'hsl(194, 34.3%, 73.1%)';
export const colourSecondaryPink = 'hsl(330, 35.2%, 78.8%)';
export const colourSecondaryPurple = 'hsl(272, 39%, 83.9%)';
export const colourSecondaryCoolGrey = 'hsl(60, 3.8%, 84.5%)';
export const colourSecondaryWarmLightGrey = 'hsl(35, 13%, 82%)';
